import { useState } from "react";
import { Modal, Checkbox } from "antd";
import "../../../assets/css/commonVessels.css";
import HButton from "../../../components/custom/input/button/Button";

const DeleteComponent = (props) => {
    const {
        confirmDisabled,
        record,
        confirmDeleteIcon,
        confirmDeleteBtnName,
        confirmDeleteComponentTitle,
        confirmDeleteComponent,
        handleDelete, // This is a function that should returns a promise and should be resolved or rejected
        modalOpen,
        setModalOpen,
        showLoadingOnly,
        showDoNotShowAgain,
        hideDeleteButton,
    } = props;
    const [loading, setLoading] = useState(false);
    const [doNotShowAgain, setDoNotShowAgain] = useState(false);

    const closeModal = () => {
        setModalOpen(false);
    };

    const handleDeleteClass = async (record) => {
        if (doNotShowAgain) {
            localStorage.setItem("dripCampaignStepRemoveModal", "true");
        }
        setLoading(true);
        try {
            await Promise.resolve(handleDelete(record));
        } catch (error) {
            console.error("Error in deleting record", error);
        } finally {
            setModalOpen(false);
            setLoading(false);
        }
    };

    return (
        <>
            <Modal
                className="confirmDeleteModal"
                data-cy="confirm-delete-modal"
                maskClosable={false}
                open={modalOpen}
                onCancel={closeModal}
                width={400}
                centered
                closeIcon={null}
                wrapProps={{
                    onClick: (e) => e.stopPropagation(),
                }}
                footer={
                    showLoadingOnly ? (
                        <></>
                    ) : (
                        <div className="d-flex align-items-center justify-content-between mt-2 w-100">
                            <div
                                className={`d-flex align-items-center justify-content-${hideDeleteButton === true ? "center" : "start"} ${
                                    hideDeleteButton === true ? "w-100" : "w-50"
                                }`}
                            >
                                <HButton
                                    buttonClassName="hs-w-95 h-45 hs-fs-16 hs-button-v-cancel"
                                    variant="cancel"
                                    onClick={() => {
                                        setModalOpen(false);
                                    }}
                                    style={{ fontWeight: 600 }}
                                    data-cy="cancel-in-delete-option"
                                >
                                    Cancel
                                </HButton>
                            </div>
                            {hideDeleteButton !== true ? (
                                <div className="w-50 d-flex align-items-center justify-content-end">
                                    <HButton
                                        loading={loading}
                                        disabled={confirmDisabled}
                                        buttonClassName="w-100 h-45 confirmDeleteBtn hs-fs-16"
                                        data-cy="confirm-delete"
                                        onClick={() => handleDeleteClass(record)}
                                        type="danger"
                                    >
                                        {confirmDeleteBtnName}
                                    </HButton>
                                </div>
                            ) : (
                                <></>
                            )}
                        </div>
                    )
                }
            >
                {showLoadingOnly ? (
                    <div className="d-flex justify-content-center align-items-center">
                        <div className="actionIconsSprite search-loading" />
                    </div>
                ) : (
                    <>
                        <div
                            className={`${confirmDeleteIcon} actionIconsSprite me-4 mb-3`}
                            data-cy="confirm-delete-icon"
                        ></div>
                        <div className="mb-1 hs-fs-16 hs-fw-700" data-cy="confirm-delete-title">
                            {confirmDeleteComponentTitle}
                        </div>
                        <div className="pb-3" data-cy="confirm-delete-description">
                            {confirmDeleteComponent}
                        </div>
                        {showDoNotShowAgain && (
                            <Checkbox
                                rounded={false}
                                item={{ label: "Don't show again" }}
                                onChange={(e) => setDoNotShowAgain(e.target.checked)}
                            />
                        )}
                    </>
                )}
            </Modal>
        </>
    );
};

export default DeleteComponent;
